function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 25A12.5 12.5 0 1125 12.5 12.51 12.51 0 0112.5 25zm0-23.5a11 11 0 1011 11 11 11 0 00-11-11z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 18.5l3.44-8.59L18.5 6.5l-3.44 8.59zm4.59-7.44l-1.9 4.74 4.74-1.9 1.9-4.74z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.94 18.06l3.06-8 5.08 5.06zm1.79-1.79l4.88-2"
});
function SvgCompass(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), _ref, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default ForwardRef;